/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import { Svg } from 'components/icons/index'
import PropTypes from 'prop-types'

function Repository({ color, width, height, ...otherProps }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
      {...otherProps}
    >
      <path
        d="M6 2C4.895 2 4 2.895 4 4V20C4 21.105 4.895 22 6 22V19C6 17.343 7.343 16 9 16H13C14.657 16 16 17.343 16 19V22H18C19.105 22 20 21.105 20 20V4C20 2.895 19.105 2 18 2H6ZM7.5 4H8.5C8.776 4 9 4.224 9 4.5V5.5C9 5.776 8.776 6 8.5 6H7.5C7.224 6 7 5.776 7 5.5V4.5C7 4.224 7.224 4 7.5 4ZM7.5 8H8.5C8.776 8 9 8.224 9 8.5V9.5C9 9.776 8.776 10 8.5 10H7.5C7.224 10 7 9.776 7 9.5V8.5C7 8.224 7.224 8 7.5 8ZM7.5 12H8.5C8.776 12 9 12.224 9 12.5V13.5C9 13.776 8.776 14 8.5 14H7.5C7.224 14 7 13.776 7 13.5V12.5C7 12.224 7.224 12 7.5 12ZM9 18C8.448 18 8 18.448 8 19V22.377C8 22.826 8.47105 23.117 8.87305 22.916L11 21.5L13.127 22.916C13.529 23.117 14 22.826 14 22.377V19C14 18.448 13.552 18 13 18H9Z"
        fill={color}
      />
    </Svg>
  )
}

Repository.defaultProps = {
  color: 'var(--white)',
  width: '24px',
  height: '24px',
}

Repository.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default Repository
